import obituaryMinimalizm from "./definitions/obituary-minimalizm.json";
import obituaryPogrubione from "./definitions/obituary-pogrubione.json";
import obituaryBlack from "./definitions/obituary-black.json";
import crossPlaque from "./definitions/cross-plaque.json";
import snitchPlaque from "./definitions/snitch-plaque.json";
import coffinPlaque from "./definitions/coffin-plaque.json";
import urnPlaque from "./definitions/urn-plaque.json";

import crossMini from "../../../img/crossPlaque1bg.png";
import obituary1Mini from "../../../img/template1.png";
import snitch1Mini from "../../../img/SnitchPlaque1.png";
import coffin1Mini from "../../../img/CoffinPlaque1.png";
import urn1Mini from "../../../img/UrnPlaque1.png";

const layouts = {
  1: {
    name: "Nekrolog",
    params: [
      {
        typeName: "Minimalizm",
        layout: obituaryMinimalizm,
        mini: obituary1Mini,
      },
      {
        typeName: "Pogrubione dane",
        layout: obituaryPogrubione,
        mini: obituary1Mini,
      },
    ],
  },
  2: {
    name: "Tabliczka na krzyż",
    params: [{ layout: crossPlaque, mini: crossMini }],
  },
  3: {
    name: "Tabliczka na znicz",
    params: [{ layout: snitchPlaque, mini: snitch1Mini }],
  },
  4: {
    name: "Tabliczka na trumnę",
    params: [{ layout: coffinPlaque, mini: coffin1Mini }],
  },
  5: {
    name: "Tabliczka na urnę",
    params: [{ layout: urnPlaque, mini: urn1Mini }],
  },
  6: {
    name: "Nekrolog czarny",
    params: [{ layout: obituaryBlack, mini: obituary1Mini }],
  },
};

export default layouts;
